import React, { useState } from "react";
import Header from "../../../components/Header";
import LeftMenu from "../../../components/LeftMenu";
import { CARD_STYLE } from "../../../constants/styles";
import QuestionnaireModeSelector from "../QuestionnaireModeSelector";
import { useParams } from "react-router-dom";
import { GREY_GRADIENT_PANEL_BACKGROUND } from "../../../constants/styles";
import {ADMIN_PANEL_BACKGROUND_COLOR } from "../../../constants/styles";
import EditQuestionnaireSectionModal from "./components/EditQuestionnaireSectionModal";
import QuestionnaireSchedulingModal from "./components/QuestionnaireSchedulingModal";
import QuestionnaireUserAllocationModal from "./components/QuestionnaireUserAllocationModal";

export default function QuestionnaireQuestionnaireEdit() {
	
	const [editSection, setEditSection] = useState(null);
	const [sectionModalOpen, setSectionModalOpen] = useState(false);
	const [scheduleOpen, setScheduleOpen] = useState(false);
	const [allocOpen, setAllocOpen] = useState(false);

  const { id } = useParams();

  const [questionnaire] = useState({
    name: "Workplace Utilisation Survey",
    status: "Active",
    frequency: "Quarterly",
    lastIssued: "10 Jan 2026"
  });

  const sections = [
    {
      id: 1,
      name: "Desk & IT",
      questions: [
        "We have enough desks to deal with our teams' needs",
        "Our desks are set up with the correct IT equipment"
      ]
    },
    {
      id: 2,
      name: "Meeting Spaces",
      questions: [
        "We can book the meeting spaces we need",
        "Informal collaboration spaces are sufficient"
      ]
    }
  ];

  const toolbarStyle = {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    padding: "10px 20px",
    borderBottom: "1px solid #ddd"
  };

  const buttonStyle = {
    padding: "6px 14px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    background: "linear-gradient(180deg, #f4f6f8, #e6e8eb)",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "600"
  };
  
  const propertiesContainer = {
	display:'flex',
	width:'calc(100% - 40px)',
	borderRadius:"10px",
	marginLeft:"20px",
	marginRight:"20px",
	marginBottom:"10px",
	marginTop:"-10px",
	flexDirection:"column",
	backgroundColor:"rgba(0,0,0,0.01)",
	paddingTop:"20px",
	paddingBottom:"10px"
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", width: "calc(100% - 60px)", marginLeft: "60px", marginTop: "60px" }}>
        <Header />
        <LeftMenu />

        {/* TOOLBAR */}
        <div style={{...CARD_STYLE, margin: "20px 30px 0 30px", padding: 0 }}>
          <div style={{...toolbarStyle, background: GREY_GRADIENT_PANEL_BACKGROUND}}>
            <button style={buttonStyle}>Save</button>
            <button style={buttonStyle}>Duplicate</button>
            <button style={buttonStyle}>Archive</button>
            <button style={buttonStyle}>Preview</button>
          </div>
        </div>

        {/* MAIN BODY */}
        <div style={{ display: "flex", margin: "0 30px 30px 30px", gap: "20px", marginTop:'20px'}}>

          {/* LEFT: STRUCTURE */}
          <div style={{ ...CARD_STYLE, flex: 2, flexDirection: "column", paddingBottom:"20px", background:ADMIN_PANEL_BACKGROUND_COLOR   }}>
            <div style={{ fontSize: "14px", fontWeight: "600", marginBottom: "10px", padding:"20px" }}>
              Structure
            </div>

			{sections.map(section => (
			  <div
			    key={section.id}
			    style={{
			      marginBottom: "18px",
			      borderRadius: "6px",
			      overflow: "hidden",
			      //border: "1px solid #e2e5e9",
			      //background: "#ffffff",
				  marginLeft:'20px',
				  marginRight:'20px'
			    }}
			  >

			    {/* SECTION HEADER BAND */}
			    <div style={{
			      height: "40px",
			      background: GREY_GRADIENT_PANEL_BACKGROUND,
			      color: "black",
			      display: "flex",
			      alignItems: "center",
			      padding: "0 12px",
			      fontSize: "12px",
			      fontWeight: "600",
			      justifyContent: "space-between"
			    }}>
			      <span>{section.name}</span>

			      <button
			        style={{
			          padding: "2px 8px",
			          fontSize: "11px",
			          borderRadius: "4px",
			          border: "1px solid #555",
			          background: "linear-gradient(180deg, #50555b, #3f444a)",
			          color: "#fff",
			          cursor: "pointer"
			        }}
			        onClick={() => {
			          setEditSection(section);
			          setSectionModalOpen(true);
			        }}
			      >
			        Edit
			      </button>
			    </div>

			    {/* QUESTIONS */}
			    <div>
			      {section.questions.map((q, i) => (
			        <div
			          key={i}
			          style={{
			            padding: "0px 12px",
			            fontSize: "12px",
			            color: "#333",
			            background: i % 2 === 0 ? "rgba(0,0,0,0.01)" : "",
			            //borderBottom: i === section.questions.length - 1 ? "none" : "1px solid #e2e5e9",
			            display: "flex",
			            alignItems: "center",
						height:'40px'
			          }}
			        >
			          {q}
			        </div>
			      ))}
			    </div>

			  </div>
			))}


            <button style={{ ...buttonStyle, alignSelf: "flex-start", marginTop: "10px", marginLeft:"20px"}}>
              + Add Section
            </button>
          </div>

          {/* RIGHT: PROPERTIES */}
          <div style={{ ...CARD_STYLE, flex: 1, flexDirection: "column", background:ADMIN_PANEL_BACKGROUND_COLOR }}>
            <div style={{ fontSize: "14px", fontWeight: "600", marginBottom: "10px", padding:"20px" }}>
              Properties
            </div>
				<div style={propertiesContainer}>
	            <div style={{ fontSize: "12px", color: "#444", marginBottom: "8px", marginLeft:"20px" }}>
	              <b>Name:</b> {questionnaire.name}
	            </div>
	
	            <div style={{ fontSize: "12px", color: "#444", marginBottom: "8px", marginLeft:"20px" }}>
	              <b>Status:</b> {questionnaire.status}
	            </div>
	
	            <div style={{ fontSize: "12px", color: "#444", marginBottom: "8px", marginLeft:"20px" }}>
	              <b>Frequency:</b> {questionnaire.frequency}
	            </div>
	
	            <div style={{ fontSize: "12px", color: "#444", marginBottom: "8px", marginLeft:"20px" }}>
	              <b>Last Issued:</b> {questionnaire.lastIssued}
	            </div>
			</div>
            <button onClick={() => setScheduleOpen(true)} style={{ ...buttonStyle, marginTop: "10px", marginLeft:"20px" }}>
              Edit Scheduling
            </button>

            <button onClick={() => setAllocOpen(true)} style={{ ...buttonStyle, marginTop: "10px", marginLeft:"5px" }}>
              Manage Allocation
            </button>
          </div>

        </div>
      </div>
	  <EditQuestionnaireSectionModal
	    open={sectionModalOpen}
	    section={editSection}
	    onClose={() => setSectionModalOpen(false)}
	    onSave={(updated) => {
	      console.log("Saved section", updated);
	      setSectionModalOpen(false);
	    }}
	  />
	  <QuestionnaireSchedulingModal
	    open={scheduleOpen}
	    onClose={() => setScheduleOpen(false)}
	    onSave={(data) => {
	      console.log("Schedule:", data);
	      setScheduleOpen(false);
	    }}
	  />
	  <QuestionnaireUserAllocationModal
	    open={allocOpen}
	    onClose={() => setAllocOpen(false)}
	    onSave={(users) => {
	      console.log("Allocated users:", users);
	      setAllocOpen(false);
	    }}
	  />
      <QuestionnaireModeSelector displayFlag="flex" />
    </>
  );
}
